<div class="captions {{ cues.length ? 'show' : 'hide' }}">
    {{#each cues as cue}}
    {{ cue.text }}
    {{/each}}
</div>

<script>
export default {
    data() {
        return {cues: []}
    }
}
</script>